import React, {useState} from 'react'
import TableauModalEdit from './TableauModalEdit'
import TableauRow from './TableauRow'
import { v4 as uuid } from 'uuid'

function TableauComponents({titre, colonnes, data, actionEdit, actionDelete, setUpdateView}) {

    const [modalEdit, setModalEdit] = useState(false)

    const [modalContext, setModalContext] = useState([])

    return (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-lg text-orange-900 uppercase bg-orange-500 border-b-2">

                    <tr>
                        {
                        colonnes.map((item) => (! item.visible || (
                            <th key={uuid()} scope="col" className="px-6 py-3">
                                {item.name}
                            </th>
                            )
                        ))
                        }
                        {
                            actionEdit===null||(
                            <th key={uuid()} scope="col" className="px-6 py-3">
                            Action
                            </th>
                            )
                        }

                    </tr>
                </thead>
                <tbody>
                        {
                        data.map((items)=>(
                            <TableauRow key={uuid()} items={items} colonnes={colonnes}
                                 setModalActive={setModalEdit} setModalContext={setModalContext} allowEdit={actionEdit===null}/>
                        ))
                        }                    
                </tbody>
            </table>

            <TableauModalEdit key={uuid()} titre={titre} 
                                IsOpen={modalEdit} 
                                setIsOpen={setModalEdit} 
                                modalContext={modalContext} 
                                fields={colonnes}
                                actionEdit={actionEdit}
                                actionDelete={actionDelete}
                                setUpdateView={setUpdateView}/>


        </div>

    )
}

export default TableauComponents